import React from 'react'

import { useStateValue } from '../HOC/StateProvider'
import { DispatchTypes } from '../../store/reducer'

import './Product.scss'
import { toast } from 'react-toastify'

const { ADD_TO_BASKET } = DispatchTypes

export interface IProduct {
  id: string
  title: string
  image: any
  price: number
  rating: number
}

const Product = ({ id, title, image, price, rating }: IProduct) => {
  const { state, dispatch } = useStateValue()
  const { basket } = state

  const addToBasket = () => {
    // dispatch the item into the data layer
    dispatch({
      type: ADD_TO_BASKET,
      item: { id, title, image, price, rating }
    })
    toast.success('Added to basket', { autoClose: 2000 })
  }

  return (
    <div className='product'>
      <div className='product__info'>
        <p>{title}</p>
        <p className='product__price'>
          <small>$</small>
          <strong>{price}</strong>
        </p>
        <div className='product__rating'>
          {Array(rating)
            .fill(null)
            .map((_, i) => (
              <p key={i}>⭐</p>
            ))}
        </div>
      </div>

      <img src={image} alt='Product' />

      <button onClick={addToBasket}>Add to Basket</button>
    </div>
  )
}

export default Product
